// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {
  FETCH_DOMAINS
} from '../actions/domainManagement'

const initialState = {
  domains: [
    {
      domainId: '12345555',
      devicesAssigned: '547',
      maxNumberOfDevices: '1000',
      startDate: 'January 1, 2019',
      startTime: '12:30 PM',
      endDate: 'January 1, 2021',
      endTime: '9:00 AM',
      macAddress: '8732498036',
      deviceIds: ['8732498035', '8732498036']
    }, {
      domainId: '12345556',
      devicesAssigned: '113',
      maxNumberOfDevices: '150',
      startDate: 'January 1, 2020',
      startTime: '12:30 PM',
      endDate: 'January 1, 2021',
      endTime: '9:00 AM',
      macAddress: '8732498036',
      deviceIds: ['8732498036']
    }, {
      domainId: '12345556',
      devicesAssigned: '16',
      maxNumberOfDevices: '150',
      startDate: 'January 1, 2020',
      startTime: '12:30 PM',
      endDate: 'January 1, 2021',
      endTime: '9:00 AM',
      macAddress: '8732498036',
      deviceIds: ['8732498036', '8732498037', '8732498038', '8732498039',
        '8732498040', '8732498041', '8732498042', '8732498043',
        '8732498044', '8732498045', '8732498046', '8732498047']
    }
  ]
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_DOMAINS:
      return {...state, domains: action.payload.domains}
    default:
      return state
  }
}

